import { Navigate } from "react-router-dom";

export default function AirConsole() {
    // return <Navigate to="logistics-monitoring" replace />;
    return <Navigate to="/air/customer/pickup" replace />;
}
